<template>
  <!-- 웹 버전 점검 화면: 닫기 수단 없이 화면 전체를 덮는다 -->
  <div class="webmaintenance noselect" @contextmenu.prevent>
    <div class="wm-stage">
      <div class="wm-card">
        <img class="wm-char" src="../assets/maintenanceChar.png" alt="" />
        <p class="wm-title">웹 버전 점검 중입니다.</p>
        <div class="wm-box">
          <p>
            지금은 웹 버전 이용이 어려운 상황이에요.<br />
            불편을 드려 죄송합니다.
          </p>
          <p>
            스토어에서
            <span class="wm-yellow">'알공'을 검색해 앱으로 이용</span>해
            주세요.<br />
            웹은 원인을 확인 중이며, 정상화되면 바로 알려드릴게요.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WebMaintenanceModal",
};
</script>

<style scoped>
/* 1920x1080 디자인 기준, 화면 비율에 맞춰 축소/확대 */
.webmaintenance {
  --u: calc(min(100vw, 177.7778vh) / 1920);
  position: fixed;
  inset: 0;
  z-index: 999999999;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.wm-stage {
  position: relative;
  width: calc(1920 * var(--u));
  height: calc(1080 * var(--u));
}

.wm-card {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) scale(1.15);
  width: calc(1582 * var(--u));
  height: calc(795 * var(--u));
  background: rgb(129, 216, 255);
  border-radius: calc(68 * var(--u));
  overflow: hidden;
}

.wm-char {
  position: absolute;
  left: 0;
  top: calc(0 * var(--u));
  width: calc(660 * var(--u));
}

.wm-title {
  position: absolute;
  left: calc(636 * var(--u));
  top: calc(70 * var(--u));
  width: calc(887 * var(--u));
  margin: 0;
  text-align: center;
  font-family: cookiebold;
  font-size: calc(64 * var(--u));
  color: #ffffff;
  -webkit-text-stroke: calc(10 * var(--u)) #0a5fc4;
  paint-order: stroke fill;
  text-shadow: 0 calc(6 * var(--u)) 0 #0a5fc4;
}

.wm-box {
  position: absolute;
  left: calc(636 * var(--u));
  top: calc(205 * var(--u));
  width: calc(887 * var(--u));
  height: calc(485 * var(--u));
  box-sizing: border-box;
  padding: 0 calc(40 * var(--u));
  background: #006dd3;
  border-radius: calc(27 * var(--u));
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: calc(55 * var(--u));
  color: #ffffff;
  font-family: cookieregular, notosansmedium;
  font-size: calc(34 * var(--u));
  line-height: 1.6;
}

.wm-box p {
  margin: 0;
}

.wm-yellow {
  color: #ffd52e;
}
</style>
